"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SwitchWithLabel = function SwitchWithLabel(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    id = _ref.id,
    onChange = _ref.onChange,
    checked = _ref.checked;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      my: "$2",
      py: "$8",
      w: "100%",
      borderBottom: "1px solid $borderDefault"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Label, {
      htmlFor: id,
      css: {
        fontSize: "$md",
        fontWeight: "$semiBold",
        color: checked ? "$textHighEmp" : "$textDisabled",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "$8",
        flex: "1 1 0"
      },
      children: [icon, label]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Switch, {
      id: id,
      checked: checked,
      onCheckedChange: onChange
    })]
  });
};
var _default = SwitchWithLabel;
exports["default"] = _default;